module.exports = __webpack_public_path__ + "images/youtube_social_icon_red.fe8ee891f21a0d64514a292b20be6c76.png";